import InstitutionalHolding from '@rebuild/materials/shared/shareholder/InstitutionalHolding.vue';

export const componentMap = {
	full: InstitutionalHolding
};
